import gql from 'graphql-tag';

export const getDOPGroups = gql`
  query getDOPGroups {
    getDOPGroups {
      id
      name
      enabled
      AORs {
        id
        name
        enabled
        abbreviation
        AORSubSystems {
          id
          name
          enabled
        }
      }
    }
  }
`;
